import axios from 'axios';

const apiUrl = 'https://api.darmant.live';

export const instance = axios.create({
    baseURL: apiUrl,
    timeout: 2000000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor
instance.interceptors.request.use(
    config => {
        // Get token from localStorage
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Response Error:', error.response.data);
            console.error('Status:', error.response.status);
            console.error('Headers:', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            console.error('Request Error:', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error:', error.message);
        }
        return Promise.reject(error);
    }
);

/* export const instanceex = axios.create({
    baseURL: `${apiUrlextenla}/`,
    timeout: 2000000,
    headers: {
        Authorization: `${fileapiToken}`, // Add token if needed
        Accept: 'application/json'
    }
});


export const authToken = token => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    };
};

export const setParams = (params = "", token = "", method = "post") => {
    const config = {
        headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
        },
    };

    if (method === "delete") {
        config.data = params; // Use `data` field for DELETE request body
    } else {
        config.params = params; // Use `params` field for query params in POST requests
    }

    return config;
};
 */